import { useDataChange } from 'Simple/Data.js'

export function useOnFilterClickAll(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change([])
  }
}
